import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcRegistration(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.39 13.049 3.676-3.677a.75.75 0 0 1 .538-.228.73.73 0 0 1 .547.228.74.74 0 0 1 .233.542.74.74 0 0 1-.233.542l-4.129 4.129a.87.87 0 0 1-.633.271.87.87 0 0 1-.632-.271l-2.029-2.029a.75.75 0 0 1-.228-.537.73.73 0 0 1 .228-.547.74.74 0 0 1 .542-.233q.31 0 .543.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 17.25A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v3.5h-.875a1.75 1.75 0 1 0 0 3.5H22zm-1.5-8.44V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25v-2.06a3.251 3.251 0 0 1 0-6.38",
    clipRule: "evenodd"
  }));
}
var IcRegistration = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRegistration));

export { IcRegistration as I };
